import {
  array,
  boolean,
  number,
  object,
  type output,
  string,
} from 'zod';

export const MAX_AWARD_TITLE_LENGTH = 250;

export enum AwardOperation {
  Create,
  Update,
}

export const awardRequestSchema = object({
  masterAwardId: number(),
  programId: number(),
  groupId: number().min(1, 'Select a group.'),
  title: string()
    .min(1, 'Enter the award title.')
    .max(MAX_AWARD_TITLE_LENGTH, `Use ${MAX_AWARD_TITLE_LENGTH} characters or fewer for the award title.`),
  summary: string().optional(),
  detail: string().optional(),
  requireWrittenNomination: boolean().optional(),
  requireCustomerReference: boolean().optional(),
  allowJointNomination: boolean().optional(),
  maxWinners: number()
    .min(1, 'Set the maximum number of winners to 1 or more.')
    .max(255, 'Set the maximum number of winners to 255 or less.')
    .optional(),
  maxFinalists: number()
    .min(1, 'Set the maximum number of finalists to 1 or more.')
    .max(255, 'Set the maximum number of finalists to 255 or less.')
    .optional(),
  eligibilityRuleCodes: array(string()).optional(),
});

export type AwardRequest = output<typeof awardRequestSchema>;

const createAwardRequestSchema = awardRequestSchema.extend({
  masterAwardId: number().min(1, 'Select an award from the master list.'),
  programId: number().min(1, 'Select a program.'),
});

export const getAwardRequestSchema = (operation: AwardOperation) => {
  return operation === AwardOperation.Create
    ? createAwardRequestSchema
    : awardRequestSchema;
};
